import {useCallback} from "react";
import {postResetCredits} from "../api";
import {AdminAction} from "../types";
import {useToast} from "use-toast-mui";

export const useResetCredits = () => {
    const toast = useToast();

    const resetCredits: AdminAction = useCallback(async (activationKey: string): Promise<void> => {
        try {
            await postResetCredits(activationKey);
        } catch (error) {
            toast.error("Error resetting credits.");
        }
    }, [toast])

    return {resetCredits}
}
